'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoginLink = require('./components/LoginLink');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LoginLink).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/login-link/index.js
// module id = 178
// module chunks = 1